export const booleanPipe = (value, pipeArg) => {

    if (pipeArg) {
        let trueString = pipeArg.split("/")[0]
        let falseString = pipeArg.split("/")[1]

        return value ? trueString : falseString
    } else {
        return value
    }

}

export const percentPipe = (value, pipeArg) => {

    if (pipeArg) {
        let maxDigits = pipeArg.split("-")[1]
        let minDigits = pipeArg.split("-")[0].split(".")[1]

        if (value.toString().split(".")[1]?.length > maxDigits) {
            return `${(value * 100).toFixed(maxDigits)}%`
        } else {
            return `${(value * 100).toFixed(minDigits)}%`
        }
    } else {
        return value
    }

}

export const measurePipe = (value, pipeArg) => {

    if (pipeArg) {
        let measureUnit = pipeArg.split(" ")[1]

        let maxDigits = pipeArg.split("-")[1].split(" ")[0]
        let minDigits = pipeArg.split("-")[0].split(".")[1]

        if (value.toString().split(".")[1]?.length > maxDigits) {
            return `${(value * 100).toFixed(maxDigits)} ${measureUnit}`
        } else {
            return `${(value * 100).toFixed(minDigits)} ${measureUnit}`
        }
    } else {
        return value
    }

}

export const numberPipe = (value, pipeArg) => {

    if (pipeArg) {
        let maxDigits = pipeArg.split("-")[1]
        let minDigits = pipeArg.split("-")[0].split(".")[1]

        if (value.toString().split(".")[1]?.length > maxDigits) {
            return value.toFixed(maxDigits)
        } else {
            return value.toFixed(minDigits)
        }
    } else {
        return value
    }
}